import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTag2LineCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 80,
		height: 80,
		rx: 40,
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M37.649 30.4356C38.7099 30.4356 39.7274 30.8571 40.4775 31.6072L49.1244 40.2542C50.6866 41.8164 50.6866 44.349 49.1244 45.9112L43.4676 51.568C41.9055 53.1301 39.3728 53.1301 37.8108 51.568L29.1637 42.9209C28.4136 42.1708 27.9922 41.1534 27.9922 40.0925V33.769C27.9922 31.928 29.4846 30.4356 31.3255 30.4356H37.649ZM37.649 33.1023H31.3255C30.9573 33.1023 30.6589 33.4008 30.6589 33.769V40.0925C30.6589 40.4461 30.7993 40.7853 31.0494 41.0353L39.6964 49.6824C40.2171 50.203 41.0614 50.203 41.582 49.6824L47.2388 44.0256C47.7596 43.5048 47.7596 42.6606 47.2388 42.1398L38.5919 33.4928C38.3418 33.2428 38.0027 33.1023 37.649 33.1023ZM34.0394 36.4832C34.8204 35.7022 36.0867 35.7022 36.8678 36.4832C37.6488 37.2642 37.6488 38.5306 36.8678 39.3117C36.0867 40.0926 34.8204 40.0926 34.0394 39.3117C33.2583 38.5306 33.2583 37.2642 34.0394 36.4832ZM39.5346 26.6647C40.5954 26.6647 41.6128 27.0861 42.363 27.8362L51.9528 37.4261C52.4735 37.9468 52.4735 38.791 51.9528 39.3117C51.4322 39.8324 50.5879 39.8324 50.0672 39.3117L40.4774 29.7219C40.2274 29.4718 39.8882 29.3313 39.5346 29.3313H33.3315C32.5951 29.3313 31.9982 28.7344 31.9982 27.998C31.9982 27.2616 32.5951 26.6647 33.3315 26.6647H39.5346Z",
		fill: "#8C8C8C"
	})]
});
export default SvgTag2LineCircle;
